/***
 * 创建人：李珊
 * 时间：2023-1-31
 * 描述: 查看素材详情
 * 使用说明:
 * 更新说明:
 */
import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { SwAudioService } from 'src/app/librarys/components/basic-components/sw-audio/sw-audio.service';
import { SwModalframeComponent } from 'src/app/librarys/components/basic-components/sw-modal-frame/sw-modal-frame.component';
import { SwVideoService } from 'src/app/librarys/components/basic-components/sw-video/sw-video.service';
import { SwMassageBoxService } from 'src/app/librarys/serves/sw-massage-box.service';
import { environment } from 'src/environments/environment';
import { KmsService } from '../../../kms.service';
import { KmsEnum } from '../../../serves/kms-enum';
import { InstanceModuleService } from '../../../serves/instance/instance.module';
declare var $;
@Component({
    selector: 'app-material-view',
    templateUrl: './material-view.component.html',
    styleUrls: ['./material-view.component.css']
})
export class MaterialViewComponent implements OnInit {
  @ViewChild('modal') modal: SwModalframeComponent;    //弹出层组件
  @Input() param:any;
  @Output() callback = new EventEmitter(); //抛出事件
  //绑定的表单数据
  resourceModel:any = {'detailObj':{}}; 
  // 素材类型下拉选项（图像、音频、视频、文档、链接）
  materialCategoryOptions:any = [];
  // 素材获取类型下拉选项
  accessTypeList:any = [{ id: 1, text: '文件导入'},{ id: 2, text: '网络抓取'},{ id: 3, text: '人工录入'}];
  docTypeOptions:any = KmsEnum.docTypeOptions;
  textTypeOptions:any = [];
  constructor(
    private instanceModuleService: InstanceModuleService,
    private swVideoService: SwVideoService,
    private swAudioService: SwAudioService,
    private box: SwMassageBoxService,
    private kmsService: KmsService
  ) {
  }

  ngOnInit() {
    this.clickLoca(this.param["selectedData"]);
  };

  //查看素材详情
  clickLoca(selectedData: any) {
    this.materialCategoryOptions = this.instanceModuleService.getResourceTypeOptions();
    // 查询素材信息
    this.kmsService.queryMaterialById(selectedData.materialId).subscribe(
    data => {
        if (data["code"] == '200') {
        if(data.data){
            this.resourceModel = data.data;
            this.resourceModel.detailObj = data.data.documentInformation ? JSON.parse(data.data.documentInformation) : {};
            if(data.data.tags && data.data.tags.length>0){
              const nameArr = data.data.tags.map(el => el.tagName);
              this.resourceModel['tagStr'] = nameArr.join(',');
            }else{
              this.resourceModel['tagStr'] = '无';
            }
            if(this.resourceModel.fileThumbnail){
              this.resourceModel['src'] = environment.staticFileUrl+this.resourceModel.fileThumbnail;
            }
            const i = this.materialCategoryOptions.find(e => e.id == this.resourceModel.materialCategory);
            this.textTypeOptions = i && i['childs'] ? i['childs'] : [];
        }else{
            this.box.danger('未查询到当前素材信息！');
        }
        }else{
        this.box.waring(data.msg);
        }
    })
  }

  // 播放音频或视频
  clickPlay(){
    if(this.resourceModel.filePath){
      if(this.resourceModel.materialCategory == 'FILE_TYPE_AUDIO'){
        this.swAudioService.openAudio(this.resourceModel.materialTitle, environment.staticFileUrl+this.resourceModel.filePath);
      }
      if(this.resourceModel.materialCategory == 'FILE_TYPE_VIDEO'){
        this.swVideoService.openVideo(this.resourceModel.materialTitle, environment.staticFileUrl+this.resourceModel.filePath);
      }
    }
  }

  // 判断是否存在该属性
  hasAttr(key){
    const i = this.materialCategoryOptions.find(e => e.id == this.resourceModel.materialCategory);
    if(i && i.recordFileds.length>0){
      let attrs = i.recordFileds;
      if(this.resourceModel.textType && i.childs.length > 0){
        let t = i.childs.find(e => e.id == this.resourceModel.textType);
        if(t && t.recordFileds.length>0){
          attrs = t.recordFileds;
        }
      }
      return attrs.find(e => e.id == key);
    }else{
      return false;
    }
  }

  // 根据字典项获取字典值
  getDictName(key,val){
    if(val){
        if(key == 'materialCategory'){
            const arr = this.materialCategoryOptions.filter(item => item.id == val);
            return arr.length>0 ? arr[0].text : '无';
        }
        if(key == 'accessType'){
            const arr = this.accessTypeList.filter(item => item.id == val);
            return arr.length>0 ? arr[0].text : '无';
        }
        if(key == 'docType'){
            const arr = this.docTypeOptions.filter(item => item.id == val);
            return arr.length>0 ? arr[0].text : '无';
        }
        if(key == 'textType'){
            const arr = this.textTypeOptions.filter(item => item.id == val);
            return arr.length>0 ? arr[0].text : '无';
        }
    }else{
        return '无';
    }
  }
}
